export default __webpack_public_path__ + "static/media/img-0086-japan-half-face.33ccec01.png";